import HttpCliente from "../HttpCliente";

// Obtener todos los módulos
export const getModulos = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Modulo/ObtenerModulos", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Obtener módulos habilitados
export const getModulosHabilitados = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Modulo/ObtenerModulosHabilitados", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Crear nuevo módulo
export const crearModulo = (token, modulo) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Modulo/CrearModulo", modulo, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Relacionar clientes con servicio
export const relacionarClientesServicio = (token, idModulo, idsClientes) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post(`/Modulo/RelacionarClientesServicio/${idModulo}`, idsClientes, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Editar módulo
export const editarModulo = (token, modulo) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Modulo/EditarModulo", modulo, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Obtener módulos por usuario
export const getModulosPorUsuario = (token, idUsuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Modulo/ObtenerModulosPorCliente/${idUsuario}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Obtener módulos por cliente específico
export const getModulosPorClienteId = (token, idCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Modulo/ObtenerModulosPorClienteId/${idCliente}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Verificar si un cliente tiene un servicio específico
export const clienteTieneServicio = (token, idCliente, nombreServicio) => {
  return new Promise((resolve, reject) => {
    getModulosPorClienteId(token, idCliente)
      .then(modulos => {
        const tieneServicio = modulos.some(modulo => 
          modulo.servicio.toLowerCase() === nombreServicio.toLowerCase()
        );
        resolve(tieneServicio);
      })
      .catch(error => {
        reject(error);
      });
  });
};